import api from './api';
import { visibleNotifications, unreadCount } from '../features/notifications/model';
export const notificationApi = {
  getNotifications: async (config = {}) => {
    const response = await api.getAuth('/notifications', config);
    return { data: visibleNotifications(response?.data?.data ?? response?.data) };
  },
  getUnreadCount: async (config = {}) => ({
    data: { count: unreadCount((await notificationApi.getNotifications(config)).data) },
  }),
  markAsRead: async (id, config = {}) =>
    (await api.putAuth(`/notifications/${id}/read`, undefined, config)).data,
  markAllAsRead: async (config = {}) =>
    (await api.putAuth('/notifications/read-all', undefined, config)).data,
  deleteNotification: async (id, config = {}) =>
    (await api.deleteAuth(`/notifications/${id}`, config)).data,
};
